export function parseBooleanInString(input: 'true'): true;
export function parseBooleanInString(input: 'false'): false;
export function parseBooleanInString(input: string): string;
export function parseBooleanInString(input: 'true' | 'false' | string) {
    if (input === 'true') {
        return true;
    }
    if (input === 'false') {
        return false;
    }
    return input;
}
